import styled from "styled-components";

export const StyledContainer = styled.div`
  padding: 5em 2em 8em;
  max-width: 1200px;
  margin: 0 auto;
`;

export const Title = styled.h2`
  font-weight: normal;
  max-width: 350px;
  margin-bottom: 3em;
`;

export const List = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 4em;
  justify-items: center;

  @media (min-width: 950px) {
    grid-auto-flow: column;
    grid-template-columns: initial;
    justify-content: space-between;
  }
`;
